import { render, staticRenderFns } from "./listtable.vue?vue&type=template&id=36142a9d&"
import script from "./listtable.vue?vue&type=script&lang=js&"
export * from "./listtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports